module.exports = __webpack_public_path__ + "static/media/night-logo.8d2756cd.svg";